import createBaseService from "@/api/base-service.ts";
import type { CaseType } from "../../types/case-type";

const branchCaseTypeService = {
	...createBaseService<CaseType>("/branch-case-types"),
};

export default branchCaseTypeService;
